import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectWithLayoutFilter } from 'shared/selectors/advancedFilters';

export const WithLayoutContainer: FC = () => {
  const { label, value } = useSelector(selectWithLayoutFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setWithLayout', arguments: [newValue || null] });
    },
    [onChange],
  );

  return <Checkbox label={label} checked={value} onChange={handleChange} />;
};
